import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { App as AntdApp, ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import 'antd/dist/reset.css';
import './App.css';

import { store } from './store';
import AppRouter from './router';

// 统一 Day.js 的月份、星期等展示语言；不改变时间值、存储格式或时区。
dayjs.locale('zh-cn');

// Ant Design主题配置
const theme = {
  token: {
    colorPrimary: '#1890ff',
    borderRadius: 6,
  },
  components: {
    Layout: {
      headerBg: '#fff',
      siderBg: '#fff',
    },
    Menu: {
      itemBg: 'transparent',
    },
  },
};

function App() {
  // Redux store 在创建时已自动从 localStorage 恢复状态
  // 不需要在这里手动恢复

  return (
    <Provider store={store}>
      <ConfigProvider
        locale={zhCN}
        theme={theme}
      >
        <AntdApp>
          <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <div className="App">
              <AppRouter />
            </div>
          </Router>
        </AntdApp>
      </ConfigProvider>
    </Provider>
  );
}

export default App;
